import React from 'react'
// import { Link } from 'react-router-dom'
import { Button, Form, Input, Modal, Header } from 'semantic-ui-react'
import auth from '../../auth.js'
import EachVideo from './EachVideo.jsx'
import Player from './Player.jsx'

import { connect } from 'react-redux'
import { closeVideo } from '../../redux/actions/videoActions.jsx'

class Videos extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      videos: [],
      filter: 'date',
      videoSearch: '',
      results: []
    }
  }

  searchVideos(e, { name, value }) {
    var searchResults = []
    this.state.videos.forEach(video => {
      if(video.title.toLowerCase().includes(value !== '' ? value.toLowerCase() : value) || video.client.toLowerCase().includes(value !== '' ? value.toLowerCase() : value)) {
        searchResults = [...searchResults, video]
      }
    })
    this.setState({ [name]: value, results: searchResults })
  }

  loadVideos() {
    auth.getVideos().then(response => {
      this.setState({
        videos: response.sort((a, b) => {
          if(a.uploadDate < b.uploadDate) { return 1; }
          if(a.uploadDate > b.uploadDate) { return -1; }
          return 0;
        })
      })
    })
  }

  nameFilter() {
    this.setState({ 
      videos: this.state.videos.sort((a, b) => {
        if(a.title.toLowerCase() < b.title.toLowerCase()) { return -1; }
        if(a.title.toLowerCase() > b.title.toLowerCase()) { return 1; }
        return 0;
      }),
      results: this.state.results.sort((a, b) => {
        if(a.title.toLowerCase() < b.title.toLowerCase()) { return -1; }
        if(a.title.toLowerCase() > b.title.toLowerCase()) { return 1; }
        return 0;
      })
    })
  }

  dateFilter() {
    this.setState({ 
      videos: this.state.videos.sort((a, b) => {
        if(a.uploadDate < b.uploadDate) { return 1; }
        if(a.uploadDate > b.uploadDate) { return -1; }
        return 0;
      }),
      results: this.state.results.sort((a, b) => {
        if(a.uploadDate < b.uploadDate) { return 1; }
        if(a.uploadDate > b.uploadDate) { return -1; }
        return 0;
      })
    })
  }

  viewFilter() {
    this.setState({ 
      videos: this.state.videos.sort((a, b) => {
        if(a.viewCount < b.viewCount) { return 1; }
        if(a.viewCount > b.viewCount) { return -1; }
        return 0;
      }),
      results: this.state.results.sort((a, b) => {
        if(a.viewCount < b.viewCount) { return 1; }
        if(a.viewCount > b.viewCount) { return -1; }
        return 0;
      })
    })
  }

  closeVideo() {
    this.props.dispatch(closeVideo())
  }

  componentDidMount() {
    this.loadVideos()
  }

  render() {
    
    const { videoSearch } = this.state

    return (
      <div>
        {/* <Player video={this.props.currentVideo} ref='currentVideo' /> */}
        <div className="videos-container">
          <div className="filter">
            <Button onClick={this.nameFilter.bind(this)}>Name</Button> | <Button onClick={this.dateFilter.bind(this)}>Upload Date</Button> | <Button onClick={this.viewFilter.bind(this)}>Most Viewed</Button>
          </div>
          <div className="search-input">
            <Form.Field fluid control={Input} name='videoSearch' value={videoSearch} placeholder='Search...' onChange={this.searchVideos.bind(this)} />
          </div>
          <div>
            {this.state.videoSearch !== '' && this.state.results.length !== 0
              ? this.state.results.length > 1
                ? <p className='results-length'>{this.state.results.length} results match your search</p>
                : <p className='results-length'>{this.state.results.length} result matches your search</p>
              : null
            }
          </div>
          <div className="videos-row">
            {this.state.videoSearch === null || this.state.videoSearch === ''
              ? this.state.videos.length > 0
                ? this.state.videos.map((video, index) => {
                    return <EachVideo video={video} index={index} key={video._id} />
                  })
                : <div className="loading-container">
                    <h2>Loading Videos...</h2><br />
                  </div>
              : this.state.results.length > 0
                ? this.state.results.map((video, index) => {
                    return <EachVideo video={video} index={index} key={video._id} />
                  })
                : <div className='no-results'>
                    <h2>No results match your search criteria</h2><br />
                  </div>
            }
          </div>
        </div>
        
        {/* <ul>
          <li><Link to='/videos/new' className='new-video'><h3>Add</h3></Link></li>
          <li> | </li>
          <li><Link to='/videos/edit' className='edit-video'><h3>Edit</h3></Link></li>
        </ul> */}

        <Modal open={this.props.currentVideo ? true : false} >
          <Modal.Header>
            {this.props.currentVideo ? <span>{this.props.currentVideo.title} <span className="company-name">{this.props.currentVideo.client === "VirtualAPT" ? null : "by " + this.props.currentVideo.client}</span></span> : null}
            <Button onClick={this.closeVideo.bind(this)}>X</Button>
          </Modal.Header>
          <Modal.Content>
            <Player video={this.props.currentVideo} ref='currentVideo' />
          </Modal.Content>
        </Modal>
      </div>
    )
  }
}

export default connect(store => {
  return { currentVideo: store.currentVideo.video }
})(Videos)